export default __webpack_public_path__ + "static/summer_containers41-9ba66a7002f3f01386833763ccb98d57.webp";